'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectScope = exports.scopeContextTypes = exports.SCOPE = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var array = _propTypes2.default.array;


var SCOPE = 'recompose-scope'; // scope key in context
var scopeContextTypes = _defineProperty({}, SCOPE, array);
var selectScope = function selectScope(ctx) {
  var stack = ctx[SCOPE];
  return stack[stack.length - 1];
};

exports.SCOPE = SCOPE;
exports.scopeContextTypes = scopeContextTypes;
exports.selectScope = selectScope;


//////////////////
// WEBPACK FOOTER
// ./~/recompose-scope/utils.js
// module id = 733
// module chunks = 0